module.exports = __webpack_public_path__ + "static/homeEmail-68cae9e9d427fefcef3e537342b8ba98.png";